module.exports = __webpack_public_path__ + "img/s3.dd01b7cc.jpg";